"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const reactstrap_1 = require("reactstrap");
const index_1 = require("../index");
const react_1 = tslib_1.__importStar(require("react"));
const overlays_1 = require("../overlays");
const react_if_1 = require("react-if");
const utils_1 = require("../utils");
exports.OsmosysToggler = ({ on, toggle, offLabel, onLabel, children, id, boldLabel = false, centered = false, disabled = false, }) => {
    const divClasses = react_1.useMemo(() => ['small', disabled ? 'text-muted' : 'cursor-pointer'], [disabled]);
    return (react_1.default.createElement(reactstrap_1.FormGroup, { className: utils_1.classnames('osmosys-toggler', !children && 'mb-0'), "data-disabled": disabled },
        react_1.default.createElement(react_if_1.When, { condition: !!children },
            react_1.default.createElement(reactstrap_1.Label, { className: boldLabel ? 'font-weight-bold' : '' }, children)),
        react_1.default.createElement(index_1.OsmosysDiv, { flexRow: true, flexRowCentered: centered },
            react_1.default.createElement(index_1.OsmosysDiv, { className: divClasses, marginRight: true, flexColCentered: true, onClick: () => {
                    if (!disabled) {
                        toggle(false);
                    }
                } },
                react_1.default.createElement(overlays_1.OsmosysTooltip, { off: disabled, label: offLabel }, offLabel)),
            react_1.default.createElement(index_1.OsmosysDiv, null,
                react_1.default.createElement(reactstrap_1.CustomInput, { type: "switch", disabled: disabled, id: id, checked: on, onChange: e => {
                        if (!disabled) {
                            toggle(e.target.checked);
                        }
                    } })),
            react_1.default.createElement(index_1.OsmosysDiv, { className: divClasses, flexColCentered: true, onClick: () => {
                    if (!disabled) {
                        toggle(true);
                    }
                } },
                react_1.default.createElement(overlays_1.OsmosysTooltip, { off: disabled, label: onLabel }, onLabel)))));
};
//# sourceMappingURL=OsmosysToggler.js.map